import "./PayoffDiagramZoomComponent.scss";
import {IComponentOptions, IPostLink, IScope} from "angular";
import {PayoffDiagramComponentController} from "../../PayoffDiagramComponent";
import {PayoffDiagramTimeInputs} from "../../models/PayoffDiagramTimeInputs";

export const PayoffDiagramZoom = "tfPayoffDiagramZoom";

export function payoffDiagramZoom(): IComponentOptions {
    return {
        templateUrl: "app/components/charts/payoff/payoff-diagram/components/zoom/PayoffDiagramZoomComponent.html",
        require: {
            diagram: "^^tfPayoffDiagram"
        },
        controllerAs: "ctrl",
        controller: PayoffDiagramZoomComponentController
    };
}

export class PayoffDiagramZoomComponentController implements IPostLink {

    public diagram: PayoffDiagramComponentController;

    public pricePoints = 5;

    public sliderSettings = {
        floor: 5,
        ceil: 35,
        vertical: true,
        onEnd: () => this.updateDiagram()
    };

    /** @ngInject */
    public constructor(private $scope: IScope) {
    }

    public $postLink(): void {
        this.updateDiagram();
    }

    private updateDiagram() {
        const settings: PayoffDiagramTimeInputs = {
            pricePoints: this.pricePoints,
            timeSeries: null
        };
        this.diagram.updateTimeInputs(settings);
    }

    public zoomIn() {
        this.pricePoints = Math.max(this.sliderSettings.floor, this.pricePoints - 1);
        this.refreshSlider();

        this.updateDiagram();
    }

    public zoomOut() {
        this.pricePoints = Math.min(this.sliderSettings.ceil, this.pricePoints + 1);
        this.refreshSlider();
        this.updateDiagram();
    }

    private refreshSlider() {
        this.$scope.$broadcast("rzSliderForceRender");
    }
}
